import React, { useEffect, useState, useRef, createRef } from "react";
import { Auth } from "@aws-amplify/auth";
import ApiService from "../ApiService";
import { Button, Badge, Container, Form, FormControl, InputGroup, Modal, Row, Col, Spinner, Overlay, Tooltip, Dropdown } from "react-bootstrap";
import {
  format_yyyy_mm_dd_to_DATETIME_MED,
  formatUSMobileNum,
  getAgeInYrsMonthsDisplay,
  getIsoToMediumFormatDatetime,
  getRegion, isValidValue
} from "../util/common.js";
import removeClass from "../util/RemoveCSS";
import MaterialTable from "material-table";
import {
  AssignmentInd,
  AssignmentReturned,
  Message,
  NoteAdd,
  PersonAdd,
  Send,
  CachedRounded,
  CloudDownload,
  Visibility,
  RateReview,
  Healing,
  EventNote  
} from "@material-ui/icons";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import PatientProfileModal from "./PatientProfileModal";
import { hideRelevantInfo, validClinicianLicenseStates } from "../util/licence-util";
import PageTitle from "./Common/PageTitle/PageTitle";
import { TbAlertTriangle, TbQuestionMark } from "react-icons/tb";
import { MdPreview } from "react-icons/md";
import { FcAutomatic } from "react-icons/fc";
import { BiMinusCircle } from "react-icons/bi";
import { clinicianIdFromRefreshAuth } from "../util/authUtil";
import ReactDOM from "react-dom";
import userImage from "../assets/user.png";
import { BsX, BsTelephoneFill, BsGeoAltFill } from "react-icons/bs";
import Image from "react-bootstrap/Image";
import { parseAxiosError } from "../util/parserHelper";
import ReassignModal from "./Common/popUpModals/ReassignModal";
import { useHistory } from "react-router-dom";
import { getSingle } from "../strapi";
import GenericConfirmModal from "./Common/popUpModals/GenericConfirmModal";
import gearStick from "../assets/images/gear-stick.png";
import { AiFillDiff } from "react-icons/ai";
import ERXModal from "./Modal/eRx/ERXModal";
import CreateChartNotesModal from "./Common/popUpModals/CreateChartNotesModal";
import moment from 'moment';
import {isIgnoreTestForDisplay, isNegativeResult, isPositiveResult} from "../util/resultUtils";
import ErxService from "../service/erxService";
import ResultDetails from "./KitDetails/ResultDetails";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  },
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  }
}));

const AppointmentMessage = data => `Hi ${data.patientName},
Thank you for your patience! Your results have come in and I would like to go over them with you.

Please book a time on my calendar that works bests for your schedule.

Here is a link to my calendar to make finding time easier:

{meetingLink}

Warmly,
${data.clinicianName} NP
`;
let defaultAppointmentMsg = null;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LabResult = () => {
  const classes = useStyles();

  const [token, setToken] = useState(null);
  const [labResults, setLabResults] = useState([]);
  const [myStateslabResults, setMyStatesLabResults] = useState([]);
  const [allStatesShow, setAllStatesShow] = useState(true);
  const [clinicianId, setClinicianId] = useState(null);
  const [licenseStates, setLicenseStates] = useState({});
  const [validStates, setValidStates] = useState([]);
  const [inValidStates, setInValidStates] = useState([]);
  const [showExternal, setShowExternal] = useState(null);
  const [showAppointment, setShowAppointment] = useState(null);
  const [showAddressDetails, setShowAddressDetails] = useState(null);
  const [noteKitId, setNoteKitId] = useState(null);
  const [noteText, setNoteText] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [loading, setLoading] = useState(true);
  const [messageModalShow, setMessageModalShow] = useState(false);
  const [messageKitId, setMessageKitId] = useState("");
  const [currRowData, setCurrRowData] = useState(null);
  const [releaseNotesModalOpen, setReleaseNotesModalOpen] = useState(false);
  const [releaseNotesRowData, setReleaseNotesRowData] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState({ address: {} });
  const [isShowOverideForManualReviewConfirmModal, setIsShowOverideForManualReviewConfirmModal] = useState(false);

  const [labResultRefreshToggle, setLabResultRefreshToggle] = useState(false);

  const [reassignModal, setReassignModal] = useState(false);
  const [activeKitId, setActiveKitId] = useState("");

  const [showChartNoteModal, setShowChartNoteModal] = useState(false);
  const [chartNotesDetails, setChartNotesDetails] = useState(null);

  const [negativeTemplates, setNegativeTemplates] = useState(null);
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxid, setERxId] = useState("");

  const showAllStateMessages = () => {
    handleSnackOpen("Showing all Lab Results", "success");
    setAllStatesShow(true);
  };

  const showMyStateMessages = () => {
    handleSnackOpen("Showing lab results for your state", "info");
    setAllStatesShow(false);
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  const triggerLabResultRefresh = () => {
    setLabResultRefreshToggle(!labResultRefreshToggle);
  };

  removeClass();

  const navigate = useHistory();

  // const navigateToDetailPage = navKitId => {
  //     navigate.push({
  //       pathname: 'LabResult',
  //       search: '?kitId=' + navKitId,
  //     })
  //   }

  const updateLabResults = async () => {
    setLoading(true);
    const clinicianId = await clinicianIdFromRefreshAuth();
    if (!clinicianId) {
      setLoading(false);
      return;
    }
    try {
      const res = await ApiService.getAssignedLabResultsAll();
      //` 1: Set All Results
      const getResults = hideRelevantInfo(res?.data, licenseStates?.inValidStates ?? []);
      setLabResults(getResults);
      //` 2: Set My State Results
      const validStates = await validClinicianLicenseStates().then(res => res);
      const myResults = getResults.filter(result => validStates.includes(result?.user?.address?.region));
      setMyStatesLabResults(myResults);
    } catch (err) {
      console.error(err);
      handleSnackOpen(`Lab results refresh failed. Reason: ${parseAxiosError(err)?.reason}`, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    clinicianIdFromRefreshAuth().then(id => setClinicianId(id));
  }, []);

  const getCmsData = async () => {
    const content = await getSingle("clinician-portal", {
      populate: {
        negativeTemplates: {
          populate: "*"
        }
      }
    });
    return {
      revalidate: 10,
      data: content
    };
  };

  useEffect(() => {
    getCmsData()
      .then(res => {
        setNegativeTemplates(res?.data?.negativeTemplates);
      })
      .catch(err => {
        console.error("CMS Data Fetch Error", err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    if (!clinicianId) {
      setLoading(false);
      return;
    }
    ApiService.getValidAndInvalidLicenseStates()
      .then(res => {
        const { validStates = [], inValidStates = [] } = res.data;
        setValidStates(validStates);
        setInValidStates(inValidStates);
        setLicenseStates({ validStates, inValidStates });
      })
      .catch(err => handleSnackOpen(`Failed getting license states. Cause: ${parseAxiosError(err)}`))
      .finally(() => setLoading(false));
  }, [clinicianId]);

  useEffect(() => {
    setLoading(true);
    if (!clinicianId) {
      setLoading(false);
      return;
    }
    updateLabResults().then(r => r);
  }, [licenseStates, labResultRefreshToggle, backdropOpen]);

  async function assignToMe(kitId) {
    setLoading(true);
    const r = await ApiService.putAssignLabResult({ kitId: kitId })
      .then(res => {
        handleSnackOpen("Assigned to you!", "success");
        triggerLabResultRefresh();
      })
      .catch(err => {
        const msg = err?.response?.data?.message ?? err?.message;
        handleSnackOpen(`Failed to assign kit. Cause: ${msg}`);
      });
  }

  async function getAssignedLabResultsAll() {
    try {
      const assignedLabResults = await ApiService.getAssignedLabResultsAll();
      setLabResults(hideRelevantInfo(assignedLabResults.data, []));
      setLoading(false);
    } catch (ex) {
      console.error(ex);
    }
  }

  function submitNotes(noteType, notes, releaseNote = false) {
    setBackdropOpen(true);
    if (!releaseNote) {
      async function putTestResultNotes() {
        try {
          // eslint-disable-next-line no-unused-vars
          const putTestResultNotes = await ApiService.putTestResultNotes(noteKitId, {
            noteType: noteType,
            notes: notes
          })
            .then(res => {
              setBackdropOpen(false);
              handleSnackOpen("Draft Saved!", "success");
            })
            .catch(error => {
              const msg = error?.response?.data?.message ?? error?.message;
              handleSnackOpen(msg, "error");
            })
            .finally(() => setBackdropOpen(false));
        } catch (err) {
          const msg = err?.response?.data?.message ?? err?.message;
          console.error(err);
          setBackdropOpen(false);
          handleSnackOpen(msg, "error");
        }
      }

      putTestResultNotes();
    } else {
      async function putTestResultNotes() {
        try {
          // eslint-disable-next-line no-unused-vars
          const putTestResultNotes = await ApiService.putTestResultNotes(noteKitId, {
            noteType: noteType,
            notes: notes
          })
            .then(res => {
              setBackdropOpen(false);
              handleSnackOpen("Draft Saved!", "success");
            })
            .catch(error => {
              const msg = error?.response?.data?.message ?? error?.message;
              handleSnackOpen(msg, "error");
            })
            .finally(() => setBackdropOpen(false));

          async function putTestResultNotesRelease() {
            try {
              // eslint-disable-next-line no-unused-vars
              const putTestResultNotesRelease = await ApiService.putTestResultNotesRelease(noteKitId)
                .then(res => {
                  setBackdropOpen(false);
                  handleSnackOpen("Result release success!", "success");
                })
                .catch(error => {
                  const msg = error?.response?.data?.message ?? error?.message;
                  handleSnackOpen(msg, "error");
                })
                .finally(() => setBackdropOpen(false));
            } catch (err) {
              const msg = err?.response?.data?.message ?? err?.message;
              console.error(err);
              setBackdropOpen(false);
              handleSnackOpen(msg, "error");
            }
          }
          putTestResultNotesRelease();
        } catch (err) {
          console.error(err);
          setBackdropOpen(false);
          handleSnackOpen(err.message, "error");
        }
      }

      putTestResultNotes();
    }
  }

  const openReleaseNotesModal = rowData => {
    setReleaseNotesModalOpen(true);
    setReleaseNotesRowData(rowData);
  };

  function releaseNotes(kitId) {
    setBackdropOpen(true);

    async function putTestResultNotesRelease() {
      try {
        // eslint-disable-next-line no-unused-vars
        const putTestResultNotesRelease = await ApiService.putTestResultNotesRelease(kitId)
          .then(res => {
            setBackdropOpen(false);
            handleSnackOpen("Note(s) Released!", "success");
          })
          .catch(error => {
            const msg = error?.response?.data?.message ?? error?.message;
            setBackdropOpen(false);
            handleSnackOpen(msg, "error");
          });
      } catch (err) {
        const msg = err?.response?.data?.message ?? err?.message;
        console.error(err);
        setBackdropOpen(false);
        handleSnackOpen(msg, "error");
      }
    }

    putTestResultNotesRelease();
  }


  const openChartNoteModal = (rowData) => { 
    setChartNotesDetails(rowData);
    setShowChartNoteModal(true);
  }

  function processAppointment(event) {
    event.preventDefault();
    const numels = document.getElementsByName("appointmentMsg").length;
    const message = document.getElementsByName("appointmentMsg")[numels - 1].value;
    setShowAppointment(false);

    async function postAppointment() {
      try {
        // eslint-disable-next-line no-unused-vars
        const postAppointment = await ApiService.postAppointment({ testResultId: noteKitId, message })
          .then(res => {
            setBackdropOpen(false);
            handleSnackOpen("Appointment Requested!", "success");
          })
          .catch(error => {
            const msg = error?.response?.data?.message ?? error?.message;
            setBackdropOpen(false);
            handleSnackOpen(msg, "error");
          });
      } catch (err) {
        const msg = err?.response?.data?.message ?? err?.message;
        console.error(err);
        setBackdropOpen(false);
        handleSnackOpen(msg, "error");
      }
    }

    postAppointment();
  }

  const handleReassignKitClose = () => {
    setReassignModal(false);
    setReassignModal(false);
    setActiveKitId("");
  };

  const handleExternalClose = () => {
    setShowExternal(false);
  };

  const handleExternalShow = (kitId, externalNote, status) => {
    setNoteKitId(kitId);
    setNoteText(externalNote);
    "RESULTS_RELEASED" === status ? setIsReadOnly(true) : setIsReadOnly(false);
    setShowExternal(true);
  };
  const handleAppointmentRequest = data => {
    const { user, clinician, kitId } = data;
    setNoteKitId(kitId);
    const patientName = `${user?.firstName} ${user?.lastName}`;
    const clinicianName = `${clinician.firstName} ${clinician.lastName}`;
    defaultAppointmentMsg = AppointmentMessage({ patientName, clinicianName });
    setShowAppointment(true);
  };

  const handleAppointmentClose = () => {
    setShowAppointment(false);
  };

  const handleAddressessClose = () => {
    setShowAddressDetails(false);
  };

  const handleAddresseeShow = patient => {
    setSelectedPatient(patient);
    setShowAddressDetails(true);
  };

  function processExternalNotes(event) {
    handleExternalClose();
    event.preventDefault();
    const numels = document.getElementsByName("externalNotesText").length;
    const notes = document.getElementsByName("externalNotesText")[numels - 1].value;
    submitNotes("external", notes);
  }

  const sendMessage = message => {
    handleSnackOpen("Sending Message...", "info");

    async function postPatientMessage() {
      try {
        // eslint-disable-next-line no-unused-vars
        const postPatientMessage = await ApiService.postPatientMessage({
          kitId: messageKitId,
          message: message
        })
          .then(res => {
            setLoading(false);
            handleSnackOpen("Message Sent!", "success");
          })
          .catch(error => {
            const msg = error?.response?.data?.message ?? error?.message;
            setBackdropOpen(false);
            handleSnackOpen(msg, "error");
          });
      } catch (err) {
        console.error(err.message);
        handleSnackOpen(err.message, "error");
      }
    }

    postPatientMessage();
  };

  const handleMessageModalset = (event, rowData) => {
    setMessageKitId(rowData.kitId);
    setMessageModalShow(true);
  };
  const navigateToKitDetailPage = rowData => {
    navigate.push({
      pathname: "KitDetails",
      search: "?kitId=" + rowData.kitId,
      state: { kitDetails: rowData }
    });
  };

  const handleManualOverideTestResultReview = rowData => {
    setCurrRowData(rowData);
    setIsShowOverideForManualReviewConfirmModal(true);
  };

  const handleManualOverideTestResultReviewConfirm = async () => {
    setLoading(true);
    await ApiService.overrideForManualClinicianReview(currRowData.kitId)
      .then(resp => {
        handleSnackOpen("Test result auto release cancelled.", "success");
      })
      .catch(err => {
        handleSnackOpen(`Test result auto release override failed. cause:${parseAxiosError(err)}`, "error");
      })
      .finally(() => {
        setLoading(false);
        setIsShowOverideForManualReviewConfirmModal(false);
        setCurrRowData(null);
        triggerLabResultRefresh();
      });
  };

  const handleManualOverideTestResultReviewCancel = async () => {
    setCurrRowData(null);
    setIsShowOverideForManualReviewConfirmModal(false);
  };

  const renderManualOverrideForClinicianReviewIfApplicable = rowData => {
    if (rowData?.status !== "AUTO_RELEASE_SCHEDULED") return;

    return {
      icon: () => (
        <div>
          <img src={gearStick} alt="Icon" width={30} height={30} />
        </div>
      ),
      tooltip: "Override for manual review",
      onClick: () => {
        handleManualOverideTestResultReview(rowData);
      }
    };
  };
  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };
  const handleSendPrescription = async (event, rowData) => {
    try {
      const userDetailRes = await ApiService.getPatientDetailByEmail(rowData?.user?.email);
      const userDetail = userDetailRes?.data;
      const photonHealthErxPatientId = userDetailRes?.data?.photonHealthErxPatientId;

      if (!userDetail) {
        setSnackOpen(true);
        setSnackSeverity("error");
        setSnackText("Patient account not found");
        return;
      }

      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
      } else {
        const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
        const eRxIdRes = await ApiService.createPatientOnPhoton({
          patientId: userDetail?.subUUID,
          firstName: userDetail?.givenName,
          lastName: userDetail?.familyName,
          dob: userDetail?.birthDate,
          sex: sexAtBirth,
          gender:userDetail?.gender,
          phone: userDetail?.phoneNumber,
          email: userDetail?.email,
          address: {
            name: {
              first: userDetail?.givenName,
              last: userDetail?.familyName
            },
            street1: userDetail?.address?.street_address,
            street2: userDetail?.address?.street_address2,
            postalCode: userDetail?.address?.postal_code,
            country: "USA",
            state: userDetail?.address?.region,
            city: userDetail?.address?.locality
          }
        });
        if (eRxIdRes?.data?.erxPhotonId?.id) {
          const res = await ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id);
          if (res.data) {
            setShowErxModal(true);
            setERxId(eRxIdRes?.data?.erxPhotonId?.id);
          }
        }
      }
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  const getAttachmentsPresignedUrl = (attachmentUrl) => {
    if(!attachmentUrl){
        handleSnackOpen('No attachment found. Try again. Contact tech if problem continues.', "error");
        return;
    }
    setLoading(true);
    try {
      (async () => {
        const resp = await ApiService.getPresignedUrl(attachmentUrl);
        const presignedUrl = resp?.data?.body?.url;
        if(!presignedUrl){
          handleSnackOpen('Failed to get presigned downlaod url. Try again. Contact tech if problem continues', "error");
          setLoading(false);
          return;
        }
        window.open(presignedUrl, "_blank");
        setLoading(false);
      })();
    } catch (error) {
      handleSnackOpen(parseAxiosError(error), "error");
      setLoading(false);
    }
  };

  if (!loading) {
    return (
      <Container fluid={"xxl"} style={{ paddingInline: 40 }}>
        <PageTitle titleName={"Lab Results"} />
        <Row>
          <div
            style={{
              width: 200,
              height: 45,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              background: "white",
              paddingInline: 12,
              borderRadius: 8,
              marginBottom: 12
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  backgroundColor: allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                  borderRadius: 5,
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  fontWeight: allStatesShow ? "800" : "400"
                }}
                onClick={showAllStateMessages}
              >
                All States
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  backgroundColor: !allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                  borderRadius: 5,
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  fontWeight: !allStatesShow ? "800" : "400"
                }}
                onClick={showMyStateMessages}
              >
                My States
              </div>
            </div>
          </div>
          <MaterialTable
            columns={[
              {
                title: "Patient Name",
                field: "user.name",
                render: rowData => <ShowProfile event={rowData} />,
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Preferred Name",
                field: "user.preferredName",
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Patient Email",
                field: "user.email",
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Kit ID",
                field: "kitId",
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Results Status",
                field: "status",
                render: rowData => {
                  if (rowData?.status === "AUTO_RELEASE_SCHEDULED") {
                    return (
                      <div>
                        <FcAutomatic />
                        <span>{rowData?.status}</span>
                      </div>
                    );
                  }
                  return <span>{rowData?.status}</span>;
                }
              },
              {
                title: "Clinician",
                field: "clinician.firstName",
                render: rowData => {
                  if (rowData.clinician !== null) {
                    return (
                      <span>
                        {rowData.clinician.firstName} {rowData.clinician.lastName}
                      </span>
                    );
                  } else {
                    return <span>Unassigned</span>;
                  }
                },
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Lab Date",
                field: "createDateTime",
                render: rowData => getIsoToMediumFormatDatetime(rowData.createDateTime),
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Results",
                field: "result",
                render: rowData => (
                  <div>
                    <ResultDetails testResults={rowData.results} displayOnlyTestResults={true} />
                  </div>
                ),
                cellStyle: {
                  width: 750,
                  minWidth: 750
                },
                headerStyle: {
                  width: 420,
                  minWidth: 420
                }
              },
              { title: "Patient Sex at Birth", field: "user.genderAtBirth" },
              {
                title: "Patient DOB",
                field: "user.dob",
                render: rowData => (
                  <>
                    <div>{format_yyyy_mm_dd_to_DATETIME_MED(rowData.user?.dob)}</div>
                    <div>{getAgeInYrsMonthsDisplay(rowData.user?.dob)}</div>
                  </>
                ),
                cellStyle: {
                  width: 200,
                  minWidth: 200
                },
                headerStyle: {
                  width: 200,
                  minWidth: 200
                }
              },
              {
                title: "Phone Number",
                field: "user.phoneNumber",
                render: rowData => formatUSMobileNum(rowData.user?.phoneNumber),
                cellStyle: {
                  width: 170,
                  minWidth: 170
                },
                headerStyle: {
                  width: 170,
                  minWidth: 170
                },
                filtering: false
              },
              { title: "Allergies", field: "user.allergies", filtering: false },
              { title: "Current Medications", field: "medications", filtering: false },
              { title: "Current Symptoms", field: "symptoms", filtering: false },
              { title: "Patient State", field: "user.address.region" },
              { title: "Product Name", field: "productName" }
            ]}
            actions={[
              rowData => ({
                icon: () => <Visibility style={{ color: "orange" }} id={"assign-" + rowData.kitId} />,
                tooltip: "View Test kit",
                onClick: () => navigateToKitDetailPage(rowData)
              }),
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") {
                    return {
                      icon: () => <PersonAdd id={"assign-" + rowData.kitId} />,
                      tooltip: "Assign To Me",
                      onClick: () => assignToMe(rowData.kitId)
                    };
                  }
                } else {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") {
                      return {
                        icon: () => <NoteAdd className="gray-button" id={"assign-" + rowData.kitId} />,
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    } else {
                      return {
                        icon: () => <NoteAdd className="gray-button" id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId} />,
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    }
                  } else {
                    return {
                      icon: () => <NoteAdd className="gray-button" id={"internal-" + rowData.kitId} name={"internal-" + rowData.kitId} />,
                      tooltip: "Assigned to another clinician OR license ineligible",
                      disabled: true
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if ((rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") || rowData.status === "IN_PROGRESS") {
                      return;
                    } else {
                      if (rowData.status === "AUTO_RELEASE_SCHEDULED") return;
                      return {
                        icon: () => <AssignmentReturned id={"release-" + rowData.kitId} name={"release-" + rowData.kitId} />,
                        tooltip: "Send Results",
                        onClick: () => {
                          setNoteKitId(rowData.kitId);
                          openReleaseNotesModal(rowData);
                        }
                      };
                    }
                  } else {
                    return {
                      icon: () => <NoteAdd id={"external-" + rowData.kitId} name={"external-" + rowData.kitId} />,
                      tooltip: "View Notes for Patient",
                      onClick: () => handleExternalShow(rowData.kitId, rowData.externalNotes, rowData.status)
                    };
                  }
                } else {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") {
                      return;
                    } else {
                      return {
                        icon: () => <Message className="gray-button" id={"external-" + rowData.kitId} name={"external-" + rowData.kitId} />,
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    }
                  } else {
                    return {
                      icon: () => <NoteAdd className="gray-button" id={"external-" + rowData.kitId} name={"external-" + rowData.kitId} />,
                      tooltip: "Assigned to another clinician OR license ineligible",
                      disabled: true
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if ((rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") || rowData.status === "IN_PROGRESS") {
                      return;
                    } else if (rowData.status !== "NEEDS_CONSULT") {
                      if (rowData.status === "AUTO_RELEASE_SCHEDULED") return;

                      return {
                        icon: () => <AssignmentInd id={"appointmentRequest-" + rowData.kitId} name={"appointmentRequest-" + rowData.kitId} />,
                        tooltip: "Appointment Request",
                        onClick: () => handleAppointmentRequest(rowData)
                      };
                    }
                  } else {
                    return;
                  }
                } else {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") {
                      return;
                    } else if (rowData.status !== "NEEDS_CONSULT") {
                      return {
                        icon: () => (
                          <AssignmentInd
                            className="gray-button"
                            id={"appointmentRequest-" + rowData.kitId}
                            name={"appointmentRequest-" + rowData.kitId}
                          />
                        ),
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    }
                  } else {
                    return;
                  }
                }
              },
              rowData => renderManualOverrideForClinicianReviewIfApplicable(rowData),
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  return;
                } else {
                  if (rowData.status !== "RESULTS_RELEASED" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician == null && rowData.status === "NEEDS_CLINICIAN_REVIEW") {
                      return;
                    } else if (rowData.externalNotes) {
                      return {
                        icon: () => <NoteAdd className="gray-button" id={"release-" + rowData.kitId} name={"release-" + rowData.kitId} />,
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    }
                  } else {
                    return;
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician == null) {
                    return;
                  } else {
                    return {
                      icon: () => <Send />,
                      tooltip: "Message Patient",
                      onClick: (e, row) => handleMessageModalset(e, row)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  rowData.clinician !== null &&
                  rowData.clinician.userId !== clinicianId
                ) {
                  return {
                    icon: () => (
                      <div id={"action-create-test-" + rowData.kitId}>
                        <CachedRounded style={{ color: "orange" }} id={"reassign-" + rowData.kitId} name={"reassign-" + rowData.kitId} />
                      </div>
                    ),
                    tooltip: "Reassign To Me",
                    onClick: () => {
                      setActiveKitId(rowData.kitId);
                      setReassignModal(true);
                    }
                  };
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician === null) {
                    return;
                  } else {
                    return {
                      icon: () => <Healing />,
                      tooltip: "Send Prescription",
                      onClick: (e, row) => handleSendPrescription(e, row)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician === null) {
                    return;
                  } else {
                    return {
                      icon: () => <EventNote />,
                      tooltip: "Create Chart Note",
                      onClick: (e, row) => {
                        openChartNoteModal(row);
                      }
                    };
                  }
                }
              },
              rowData => {
                if (rowData?.attachments?.length) {
                  return {
                    icon: () => <CloudDownload />,
                    tooltip: "Download Attachment",
                    onClick: () => {
                      getAttachmentsPresignedUrl(rowData.attachments[0]);
                    }
                  };
                }
              }
            ]}
            data={allStatesShow ? labResults : myStateslabResults}
            options={{
              filtering: false,
              exportButton: true,
              headerStyle: { position: "sticky", top: 0 },
              maxBodyHeight: "630px",
              search: true,
              pageSize: 50,
              pageSizeOptions: [50, 100, 200],
              emptyRowsWhenPaging: false,
              actionsColumnIndex: 1,
              draggable: false,
              showTitle: false
            }}
            // onRowClick={(event, rowData) => navigateToDetailPage(rowData?.kitId)}
          />
        </Row>

        {/* //& Reassign to Me Modal */}
        {reassignModal && (
          <ReassignModal handleClose={handleReassignKitClose} kit={activeKitId} recordType="LAB_RESULT" onRefresh={triggerLabResultRefresh} />
        )}
        {/* Chart Note Modal */}
        {showChartNoteModal && (
          <CreateChartNotesModal
            show={showChartNoteModal}           
            onHide={() => {
              setShowChartNoteModal(false);
            }}
            referenceId={chartNotesDetails?.kitId}
            referenceType="TEST_RESULT"
            chartNotesDetails={chartNotesDetails}
            patientDetails={chartNotesDetails?.user}
          />  
        )}

        {showErxModal && <ERXModal show={showErxModal} onHide={hideErxModal} eRxid={eRxid} />}

        {
          <GenericConfirmModal
            title={"Auto Test result release manual review override"}
            isShow={isShowOverideForManualReviewConfirmModal}
            onConfirmCb={() => handleManualOverideTestResultReviewConfirm()}
            bodyMsg={`<p>This will cancel the scheduled auto test result release and will require a clinician to review & release process. <br><br>Please confirm your action</p>`}
            handleCloseCb={() => handleManualOverideTestResultReviewCancel(false)}
            confirmBtnCaption={"Override"}
          />
        }

        <Modal show={showExternal} onHide={handleExternalClose} backdrop={"static"}>
          <Modal.Header closeButton>
            <Modal.Title>Notes to Patient</Modal.Title>
          </Modal.Header>
          <InputGroup>
            <FormControl
              id={"externalNotesText"}
              name={"externalNotesText"}
              as="textarea"
              rows="20"
              cols="120"
              aria-label="With textarea"
              disabled={isReadOnly}
            >
              {noteText}
            </FormControl>
          </InputGroup>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleExternalClose}>
              Close
            </Button>
            {isReadOnly ? (
              ""
            ) : (
              <Button variant="primary" onClick={processExternalNotes} type={"submit"}>
                Save Changes
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <PatientProfileModal show={showAddressDetails} onHideModal={() => handleAddressessClose()} user={selectedPatient} />
        <Modal
          show={showAppointment}
          onHide={() => handleAppointmentClose()}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Form onSubmit={processAppointment}>
            <Modal.Header id="modalHeader">
              <Modal.Title>Appointment Details</Modal.Title>
            </Modal.Header>
            <Modal.Body id="modalBody">
              <Form.Group>
                <Form.Control
                  id="borderless"
                  name={"appointmentMsg"}
                  as="textarea"
                  rows="14"
                  cols="120"
                  aria-label="With textarea"
                  disabled={false}
                  defaultValue={defaultAppointmentMsg}
                ></Form.Control>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleAppointmentClose}>
                Cancel
              </Button>
              <Button id="msg_reply" class="replyButton sendButton text-right" type={"submit"}>
                Send <i className="fa fa-paper-plane" aria-hidden="true"></i>
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <Backdrop className={classes.backdrop} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={handleSnackClose} severity={snackSeverity}>
            {snackText}
          </Alert>
        </Snackbar>
        <SendMessageModal show={messageModalShow} onHide={() => setMessageModalShow(false)} sendMessage={sendMessage} />
        <ReleaseNotesModal
          show={releaseNotesModalOpen}
          onHide={() => setReleaseNotesModalOpen(false)}
          releaseNotesRowData={releaseNotesRowData}
          submitNotes={submitNotes}
          handleSnackOpen={handleSnackOpen}
          templates={negativeTemplates}
        />
      </Container>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
      </Container>
    );
  }
};

function ReleaseNotesModal(props) {
  const [messageText, setMessageText] = useState("");
  const [detected, setDetected] = useState([]);
  const [notDetected, setNotDetected] = useState([]);
  const [inconclusiveTests, setInconclusiveTests] = useState([]);
  const [contactSupport, setContactSupport] = useState(false);
  const [resolved, setResolved] = useState(false);
  const [clinicianName, setClinicianName] = useState();

  const [testType, setTestType] = useState("");
  const [genderType, setGenderType] = useState("");
  let TEMPLATE = props.templates;

  useEffect(() => {
    let detectedSaved = [];
    let notDetectedSaved = [];
    let inconclusiveSaved = [];

    if (props.releaseNotesRowData.results) {
      const filteredResults = props.releaseNotesRowData?.results?.filter(result => !isIgnoreTestForDisplay(result)) || [];
      filteredResults.map(individualTest => {
        if (isNegativeResult(individualTest)) {
          notDetectedSaved.push(individualTest);
        } else if (isPositiveResult(individualTest)) {
          detectedSaved.push(individualTest);
        } else {
          inconclusiveSaved.push(individualTest);
          setContactSupport(true);
        }
      });
    }
    setDetected(detectedSaved);
    setNotDetected(notDetectedSaved);
    setInconclusiveTests(inconclusiveSaved);
    setMessageText(props.releaseNotesRowData.externalNotes);
  }, [props]);

  useEffect(() => {
    (async () => {
      const clinicianId = await clinicianIdFromRefreshAuth();
      if (clinicianId) {
        const res = await ApiService.getClinicianProfile(clinicianId);
        if (res?.data?.firstName && res?.data?.lastName) {
          setClinicianName(res.data.firstName + " " + res.data.lastName);
        }
      }
    })();
  }, []);

  const submitSaveDraft = () => {
    if (messageText !== "") {
      props.submitNotes("external", messageText, false);
      props.onHide();
    }
  };

  const submitReleaseNotes = () => {
    if (messageText !== "") {
      props.submitNotes("external", messageText, true);
      props.onHide();
    }
  };

  const handleTemplateApplication = async e => {
    let currGenderType = e.target.value;
    let selectedOne = testType?.types?.find(testType => testType.name === currGenderType);
    setGenderType(currGenderType);

    const patientName = props?.releaseNotesRowData?.user?.firstName + " " + props?.releaseNotesRowData?.user?.lastName;
    if (!selectedOne?.name || !selectedOne?.content) {
      alert("There was an error applying the template. Please reset & try again.");
      return;
    }
    if (!patientName) {
      window.confirm("There was an error fetching Patient's Name Automatically, please go ahead and manually enter patient name in the message.");
    }
    if (!clinicianName) {
      window.confirm(
        "We noticed you haven't entered your name in Profile Details. Please make sure to fill your details in Profile Page or please manually enter your name/signature in the message."
      );
    }

    let message = selectedOne?.content?.replace(/{{patientName}}/g, patientName);
    message = message?.replace(/{{clinicianName}}/g, clinicianName);
    setMessageText(message);
  };

  const handleClearAndClose = () => {
    setMessageText("");
    setGenderType("");
    setTestType();
    props.onHide();
  };

  const resetTemplate = () => {
    setTestType();
    setGenderType("");
  };

  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Form id={"sendMessageForm"}>
        <Modal.Header id="modalHeader">
          <Modal.Title>Send Results</Modal.Title>
        </Modal.Header>
        {!contactSupport && (
          <>
            <Modal.Body id="modalBody">
              <Form.Group controlId="formLink">
                <Row>
                  <Col style={{ flex: 1.6 }}>
                    <Form.Label>Message Preview</Form.Label>
                    <Form.Control
                      style={{ border: "1px solid lightgray", background: "rgba(0,0,0,0.05)" }}
                      as="textarea"
                      rows={10}
                      value={messageText}
                      onChange={e => setMessageText(e.target.value)}
                    />
                  </Col>
                  <Col style={{ flex: 0.4 }}>
                    <b>Patient Demographic Details</b>
                    <div style={{ textAlign: "left" }}>
                      Name : &nbsp; {props.releaseNotesRowData?.user?.firstName} {props.releaseNotesRowData?.user?.lastName}
                    </div>
                    <div style={{ textAlign: "left" }}>Email : &nbsp; {props.releaseNotesRowData?.user?.email}</div>
                    <div style={{ textAlign: "left" }}>Phone : &nbsp; {props.releaseNotesRowData?.user?.phoneNumber}</div>
                    <div style={{ textAlign: "left" }}>State : &nbsp; {props.releaseNotesRowData.user?.address?.region}</div>
                    <div style={{ textAlign: "left" }}>DOB : &nbsp; {props.releaseNotesRowData?.user?.dob}</div>
                    <div style={{ textAlign: "left" }}>Sex Assigned : &nbsp; {props.releaseNotesRowData?.user?.genderAtBirth}</div>
                  </Col>
                </Row>
                <hr></hr>
                <Row style={{ display: "flex", justifyContent: "space-between", marginLeft: 0 }} className="TestResult">
                <ResultDetails testResults={props.releaseNotesRowData?.results} displayOnlyTestResults={true} />
                  {TEMPLATE?.length && (
                    <Col style={{ background: "#866BD9", maxWidth: 250, borderRadius: 10 }}>
                      <h4 style={{ width: "100%", textAlign: "center", paddingTop: 8 }}>Templates</h4>
                      <Col>
                        <Form.Select
                          value={testType?.name || ""}
                          onChange={e => {
                            const test = TEMPLATE?.find(item => item.name === e.target.value);
                            setTestType(test);
                            setGenderType("");
                          }}
                          style={{ width: "100%", height: 30, borderRadius: 5, background: "white", marginTop: 10 }}
                        >
                          <option value="" default disabled>
                            Select Test
                          </option>
                          {TEMPLATE?.map((test, ind) => {
                            return (
                              <option key={ind} value={test.name}>
                                {test.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {testType?.types?.length && (
                          <Form.Select
                            value={genderType || ""}
                            onChange={handleTemplateApplication}
                            style={{ width: "100%", height: 30, borderRadius: 5, background: "white", marginTop: 10 }}
                          >
                            <option value="" default disabled>
                              Select Template
                            </option>
                            {testType?.types?.map((fid, ind) => {
                              return (
                                <option key={ind} value={fid.name}>
                                  {fid.name}
                                </option>
                              );
                            })}
                          </Form.Select>
                        )}
                      </Col>
                      {testType && (
                        <div
                          style={{ cursor: "pointer", width: "100%", marginLeft: 5, marginRight: 5, paddingTop: 10, textAlign: "center" }}
                          onClick={resetTemplate}
                        >
                          <u>Reset</u>
                        </div>
                      )}
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" type="button" onClick={handleClearAndClose}>
                Cancel
              </Button>
              <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitSaveDraft()}>
                Save Draft
              </Button>
              <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitReleaseNotes()}>
                Send <i className="fa fa-paper-plane" aria-hidden="true"></i>
              </Button>
            </Modal.Footer>
          </>
        )}
        {contactSupport && (
          <>
            <Modal.Body className="onboard-modal">
              <h2 className="mb-20 text-center">Some results were rejected and/or the specimen was not provided. Contact support for next steps.</h2>
              <div className="flex align-item-center">
                <Form.Check
                  className="mr-20"
                  checked={resolved}
                  type="checkbox"
                  label="This has been resolved"
                  onChange={e => setResolved(!resolved)}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                id="msg_reply"
                class="replyButton sendButton text-right"
                onClick={() => {
                  if (resolved) {
                    setContactSupport(false);
                  } else {
                    props.handleSnackOpen("you must check that this has been resolved before moving on", "error");
                  }
                }}
              >
                Send <i className="fa fa-paper-plane" aria-hidden="true"></i>
              </Button>
            </Modal.Footer>
          </>
        )}
      </Form>
    </Modal>
  );
}

function SendMessageModal(props) {
  const [message, setMessage] = useState("");
  const [addedMessage, setAddedMessage] = useState(false);

  const submitCalendlyForm = () => {
    setAddedMessage(true);
    if (message !== "") {
      props.sendMessage(message, () => setMessage(false));
      props.onHide();
    }
  };

  useEffect(() => {
    setMessage("");
    setAddedMessage(false);
  }, [props]);

  return (
    <Modal {...props} size="lg" backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered>
      <Form>
        <Modal.Header id="modalHeader">
          <Modal.Title>Message Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modalBody">
          {message === "" && addedMessage && <p className="text-red">Make sure you add text</p>}
          <Form.Group controlId="formLink">
            <Form.Control
              id="borderless"
              placeholder="Enter your message here"
              as="textarea"
              rows={5}
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => props.onHide()}>
            Cancel
          </Button>
          <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitCalendlyForm()}>
            Send <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

const TooltipContent = ({ onClose, user }) => {
  return (
    <div
      style={{
        width: "30vw",
        height: "auto",
        padding: "25px",
        background: "white",
        borderRadius: "0px",
        color: "black",
        border: "1px solid lightgray",
        display: "block",
        boxShadow: "0 4px 4px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Row>
        <Col md={3}>
          <div>
            <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage} />
          </div>
        </Col>
        <Col md={8}>
          <div className="userName">{user?.name}</div>
          <div>
            <BsGeoAltFill /> {user?.address?.locality}, {user?.address?.region}
          </div>
        </Col>
        <Col md={1}>
          <BsX className="pointer" onClick={onClose} />
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Sex at birth:</span> {user?.gender}
        </Col>
        <Col>
          <span className="modelLabel">DOB:</span> {format_yyyy_mm_dd_to_DATETIME_MED(user?.dob)}
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Address:</span> {user?.address?.street_address}
          {user?.address?.locality}, {user?.address?.region} {user?.address?.postal_code}
        </Col>
        <Col>
          <span className="modelLabel">Phone:</span> {user?.phoneNumber}
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col>
          <span className="modelLabel">Allergies:</span> {user?.allergies}
        </Col>
        <Col>
          <span className="modelLabel">Symptoms:</span> {user?.symptoms}
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Medication:</span> {user?.medication}
        </Col>
        <Col>
          <span className="modelLabel">Sex at birth:</span> {user?.genderAtBirth}
        </Col>
      </Row>
    </div>
  );
};

function ShowProfile({ event }) {
  const [showTooltip, setShowTooltip] = useState(false);

  const closeTooltip = () => {
    setShowTooltip(false);
  };

  const openTooltip = () => {
    setShowTooltip(true);
  };
  const ref = useRef(null);

  const getTarget = () => {
    return ReactDOM.findDOMNode(ref.current);
  };

  return (
    <div ref={ref}>
      <div style={{ color: "#866BD9", cursor: "pointer", textDecoration: "underline" }} onMouseOver={openTooltip} onMouseOut={closeTooltip}
      onClick={() => {
        window.open(`/PatientProfile?patientId=${event?.user?.userId}&idType=sub`, "_blank");
      }}
      >
        {event?.user?.name}
      </div>
      <Overlay rootClose target={getTarget} show={showTooltip} placement="top" onHide={closeTooltip}>
        <Tooltip id="test">
          <TooltipContent user={event?.user} onClose={closeTooltip} />
        </Tooltip>
      </Overlay>
    </div>
  );
}

export default LabResult;
